// import React from "react";

// const Filters = ({ searchResult }) => {
//   const vehicles = searchResult.results;
//   console.log(vehicles);

//   return (
//     <>
//       <div className="search-product--filter">
//         <h3 className="h3">Select Filters</h3>
//         <div className="search-product--filter-group mb-4">
//           <h4 className="h4">Cab Type</h4>
//           <ul className="search-product--filter-group-list ">
//             <li>
//               <input type="checkbox" /> Hatchback
//             </li>
//             <li>
//               <input type="checkbox" /> Sedan
//             </li>
//             <li>
//               <input type="checkbox" /> SUV
//             </li>
//           </ul>
//         </div>
//         <div className="search-product--filter-group mb-4">
//           <h4 className="h4">Price</h4>
//           <ul className="search-product--filter-group-list ">
//             <li>
//               <input name="price-filter" type="radio" /> Hatchback
//             </li>
//             <li>
//               <input name="price-filter" type="radio" /> Sedan
//             </li>
//             <li>
//               <input name="price-filter" type="radio" /> SUV
//             </li>
//           </ul>
//         </div>
//       </div>
//     </>
//   );
// };
// export default Filters;

import React, { useState } from "react";

const Filters = ({ searchResult, onFilterChange, onSortChange }) => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [priceSort, setPriceSort] = useState("");

  // Extract unique vehicle categories (e.g., "HONDA CITY", "TOYOTA HYCROSS")
  const vehicleCategories = [
    ...new Set(searchResult?.results?.map((car) => car.vehicle_category)),
  ];

  // Handle category selection (checkbox)
  const handleCategoryChange = (category) => {
    const updatedCategories = selectedCategories.includes(category)
      ? selectedCategories.filter((c) => c !== category)
      : [...selectedCategories, category];
    setSelectedCategories(updatedCategories);
    onFilterChange(updatedCategories);
  };

  // Handle price sorting (radio)
  const handlePriceSort = (sortOrder) => {
    setPriceSort(sortOrder);
    onSortChange(sortOrder);
  };

  return (
    <div className="search-product--filter">
      <h3 className="h3">Filters & Sorting</h3>

      {/* Vehicle Category Filter */}
      <div className="search-product--filter-group mb-4">
        <h4 className="h4">Vehicle Type</h4>
        <ul className="search-product--filter-group-list">
          {vehicleCategories.map((category, index) => (
            <li key={index}>
              <label>
                <input
                  type="checkbox"
                  checked={selectedCategories.includes(category)}
                  onChange={() => handleCategoryChange(category)}
                />
                {category}
              </label>
            </li>
          ))}
        </ul>
      </div>

      {/* Price Sorting */}
      <div className="search-product--filter-group mb-4">
        <h4 className="h4">Sort By</h4>
        <ul className="search-product--filter-group-list">
          <li>
            <label>
              <input
                type="radio"
                name="price-sort"
                checked={priceSort === "low-to-high"}
                onChange={() => handlePriceSort("low-to-high")}
              />
              Price: Low to High
            </label>
          </li>
          <li>
            <label>
              <input
                type="radio"
                name="price-sort"
                checked={priceSort === "high-to-low"}
                onChange={() => handlePriceSort("high-to-low")}
              />
              Price: High to Low
            </label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Filters;